//////////////////////////////////////////
//	jQuery common
//////////////////////////////////////////
(function($) {

$(function(){
  "use strict";

  //// pageScroll ////
  $('.scroll[href^="#"]').click(function(e) {
    var id = $(this).attr("href");
    var target = $(id).offset().top;
    $('html, body').animate({
      scrollTop:target
    }, 500);
    e.preventDefault();
  });

  // menu
  var menuBtn = $('#js_menu_btn');
  var gnav = $('#js_gnav');
  $(menuBtn).click(function(e){
    if($(this).is('.is_open')) {
      $(this).removeClass('is_open')
      $(gnav).css('height','').fadeOut(300);
    } else {
      $(this).addClass('is_open')
      $(gnav).css('height',window.innerHeight).fadeIn(300);
    }
    e.preventDefault();
  });

  //// gnav
  $('.gnav__list > li[data-tap-nav]').on ('click',function(){
    if($(this).is('.current')) {
      $(this).removeClass('current');
    } else {
      $(this).addClass('current');
    }
  });
  //// header nav

  $('.gnav__list > li[data-hover-nav]').hover(function(){
    $(this).addClass('is_hover');
    }, function(){
      $(this).removeClass('is_hover').stop();
  });



  var wWidth = $(window).width();
  $(window).on('resize',function(){
    var wW = $(window).width();
    imgBg();
  });

  imgBg();
  function imgBg() {
    $('[data-img="bg"]').each(function(){
      var mvImg = $('.bg_img',this).attr('src');
      $(this).css('background-image','url('+mvImg+')');
    });
  }
  $('.top-mv-slide').slick({
    autoplay: true,
    arrows: false,
    fade: true,
    speed: 2000,
  });

  $('.photo-slide').slick({
    autoplay: false,
    arrows: true
  });

  var pagetopBtn = $('#js_pagetop');
  var startPos = 0,winScrollTop = 0;
  $(window).on("scroll", function() {
    winScrollTop = $(this).scrollTop();
    if (winScrollTop > 100) {
      $(pagetopBtn).fadeIn(300);
    } else {
      $(pagetopBtn).fadeOut(300);
    }
    var scrollHeight = $(document).height();
    var scrollPosition =  $(window).height() + $(window).scrollTop();
    var footHeight = $('.l-footer').innerHeight();
    if ( scrollHeight - scrollPosition  <= footHeight - 50 ) {
      $(pagetopBtn).addClass('is_position');
    } else {
      $(pagetopBtn).removeClass('is_position');
    }
  });

  $('#js_sitemap_tab').on('click',function(e){
    if($(this).is('.is_open')) {
      $(this).removeClass('is_open');
      $(this).next().slideUp();
    } else {
      $(this).addClass('is_open');
      $(this).next().slideDown();
    }
    e.preventDefault();
  });
  $('.prof-list .has-message .prof-list__front, .prof-list .has-message .prof-list__back').on('click',function(e){
    if($(this).parent().is('.is-on')) {
      $(this).parent().removeClass('is-on');
    } else {
      $(this).parent().addClass('is-on');
    }
    e.preventDefault();
  });
});

})(window.jQuery);
